export default __webpack_public_path__ + "static/fixed-buy-e7ec222a5036ab88daa573fbfb41e0a5.png";